<template>
  <em class="paging-summary"><span v-if="last > 0">{{first}} - {{last}} of </span>{{meta.total_results}} record(s) found</em>
</template>

<script>
  export default {
    name: 'PagingSummary',
    props: ['value'],
    computed:{
      meta:{
          get: function(){
              return this.value;
          }
      },
      first: function(){
        return this.value.per_page * (this.value.page - 1) + 1;
      },
      last: function(){
        var tmp = this.value.per_page * this.value.page;
        if (this.value.total_results < tmp){
          return this.value.total_results;
        }
        return tmp;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/PagingSummary.vue